module.exports = __webpack_public_path__ + "img/SI5026237.7b906795.png";